import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import { CouponsFormValues } from "src/models/Coupons.model";
import CouponForm from "../Layouts/CouponForm";
import { useAddCouponMutation } from "src/services/CouponService";
import moment from "moment";

type Props = {
  onClose: () => void;
};

const AddCouponWrapper = ({ onClose }: Props) => {
  const today = moment(new Date()).format("YYYY-MM-DD");

  // Form Initial Values
  const initialValues: CouponsFormValues = {
    couponCode: "",
    minOrderAmount: "",
    discountType: "",
    discountValue: "",
    startsDate: today,
    expiryDate: "",
    product: "",
    maxCount: "",
    student: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    couponCode: string().required("Please enter coupon code"),
    minOrderAmount: string().required("Please enter minimum order amount"),
    discountType: object().required("Please select discount type"),
    discountValue: string().required("Please enter discount value"),
    startsDate: string().required("Please enter start date"),
    maxCount: string().required("Please enter max count"),
  });

  const [addCoupon] = useAddCouponMutation();

  // Handle Submit
  const handleSubmit = (
    values: CouponsFormValues,
    { setSubmitting, resetForm }: FormikHelpers<CouponsFormValues>
  ) => {
    let productPayload = {};
    if (values.product?.length) {
      productPayload = {
        product: values.product.map((p: any) => p.value),
        isForAllProduct: false,
      };
    } else {
      productPayload = {
        isForAllProduct: true,
      };
    }
    let studentPayload = {};
    if (values.student?.length) {
      studentPayload = {
        student: values.student.map((s: any) => s.value),
        isForAllStudent: false,
      };
    } else {
      studentPayload = {
        isForAllStudent: true,
      };
    }
    const payload = {
      couponCode: values.couponCode,
      minOrderAmount: Number(values.minOrderAmount),
      discountType: values.discountType?.value,
      discountValue: Number(values.discountValue),
      startsDate: values.startsDate,
      expiryDate: values.expiryDate,
      product: values?.product?.value,
      maxCount: Number(values.maxCount),
      student: values.student?.value,
      ...productPayload,
      ...studentPayload,
    };
    addCoupon(payload).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="md" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <CouponForm
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddCouponWrapper;
